// extracted by mini-css-extract-plugin
export default {"root":"Tag_root__mkEYj","close":"Tag_close__FHtGu","red":"Tag_red__2jGjG","black":"Tag_black__TvD5E","white":"Tag_white__GChvm"};